module.exports = __webpack_public_path__ + "img/B911.958fa4e4.jpg";